<template>
  <div class="hle-boq-builder-page hle-boq-breakdown-page hle-history-breakdown-page">
    <BreadcrumbsProject
        v-if="!isDeluxeLayout"
        :breadcrumbs="[
             {
                link : '/high-level-estimates',
                title : $t('Bidding'),
                isRouterLink: true
            },
            {
                link : '/high-level-estimates/' + hleProjectId + '/bill-of-quantities',
                title : (hleProject.projectName || '-' )+ ' - ' + $t('Bidding Module.Detailed Estimates'),
                isRouterLink: true
            },
            {
                link : '/high-level-estimates/' + hleProjectId + '/bill-of-quantities/' + boqId + '/history',
                title : (boqItem.name  || '') + ' - '+ $t('History'),
                isRouterLink: true
            },
            {
                link : '/high-level-estimates/' + hleProjectId + '/bill-of-quantities/' + boqId + '/history/breakdown/' + parentId + '?revisionId=' + revisionId,
                title : (section.name  || '') ,
                isRouterLink: true
            },
        ]"
        />
    <div v-if="isDeluxeLayout" class="hle-boq-breakdown-back d-print-none">
        <router-link :to="{ name: 'HleBoqItemsHistory', params: { id: hleProjectId, boqId: boqId } }">
            <i class="fa-solid fa-chevron-left"></i>
            {{ $t('Back to Previous Page') }}
        </router-link>
    </div>
    <div class="card hle-bidding-card hle-boq-builder-card hle-boq-breakdown-card hle-history-breakdown-card">
        <div class="card-header bg-white hle-boq-builder-card__header">
            <div class="d-flex justify-content-between hle-boq-builder-header hle-boq-breakdown-header">
                <div class="hle-boq-builder-title">
                    <span class="hle-estimate-eyebrow">{{ $t('Breakdown') }}</span>
                    <h4 class="text-capitalize">{{ section.name || '-' }}</h4>
                    <span class="hle-boq-breakdown-subtitle">{{ boqItem.name || '-' }} — {{ $t('History') }}</span>
                </div>
            </div>
        </div>
        <div class="card-body hle-boq-builder-card__body">
            <div class="hle-boq-breakdown-toolbar">
              <div class="hle-boq-breakdown-action-group hle-boq-breakdown-action-group--filters">
                <button class="btn hle-boq-builder-action hle-boq-breakdown-action hle-boq-breakdown-action--secondary"
                @click="()=>{ OpenFilter = !OpenFilter}" :title="$t('Filter Line Items')"
                >
                    <i class="fa-solid fa-filter"></i> {{$t('Filter')}} 
                </button>
                <button class="btn hle-boq-builder-action hle-boq-breakdown-action hle-boq-breakdown-action--secondary" :title="$t('Filter Columns')"
                data-bs-toggle="modal" data-bs-target="#BoqColumnFilter"
                >
                    <i class="fa-solid fa-eye"></i> {{$t('Columns')}} 
                </button>
              </div>
              <div class="hle-boq-breakdown-note">
                <FigureCurrencyNote :currency="boqItem.currencyId" />
              </div>
            </div>
            <div class="row hle-history-breakdown-filters" v-if="OpenFilter">
                <div class="col-md-6 pb-2" v-if="OpenFilter">
                    <div class="form-group ">
                        <label class="d-flex justify-content-between">
                            <a>{{$t('Cost Category')}} </a>
                            <span role="button" class="text-danger text-decoration-underline" @click="ClearField(2)"><i class="fa-solid fa-xmark "></i> {{$t('Clear Field')}}</span>
                        </label>
                        <Multiselect 
                        :multiple="true" :options="searchableCostCodes" 
                        :placeholder="$t('Search Here')"
                        v-model="selectedCostCode" :max-height="300"
                        label="costName" track-by="_id"/>
                    </div>
                </div>
                <div class="col-md-6 pb-2" v-if="OpenFilter">
                    <div class="form-group ">
                        <label class="d-flex justify-content-between">
                            <a>{{$t('Space ID')}} </a>
                            <span role="button" class="text-danger text-decoration-underline" @click="ClearField(1)"><i class="fa-solid fa-xmark "></i> {{$t('Clear Field')}}</span>
                        </label>
                        <Multiselect 
                        :multiple="true" :options="searchableAreas" 
                        :placeholder="$t('Search Here')"
                        v-model="selectedArea"  :max-height="300" />
                    </div>
                </div>
            </div>
            <Loader  v-if="!dataReady"/>
            <BoqItemTableBreakdownReadOnly
                v-else
                class="hle-boq-breakdown-table hle-history-breakdown-table"
                :rowDatas="lineItems"
                :selectedColumns="selectedColumns"
            />
        </div>
    </div>
    <ModalLineItemColumnFilter :UpdateSelectedColumn="ChangeSelectecColumnValue"/>
  </div>
</template>


<script>
import BreadcrumbsProject  from '@/components/projectInformation/BreadcrumbsProject.vue'
import BoqItemTableBreakdownReadOnly  from '@/components/boq/BoqItemTableBreakdownReadOnly.vue'
import ModalLineItemColumnFilter from '@/components/boq/ModalLineItemColumnFilter.vue'
import {GetHleNewBoqCreatorSectionsRevisionsSection, GetHighLevelBoqHistoryLineItemsByBits, GetHighLevelBoq, GetHighLevelProject} from '@/actions/boqActions.js'
import {LinkList,GetDistinctValues, GetDistinctValuesObject} from '@/helpers/utilities.js'
import 'dotenv/config'
import Multiselect from 'vue-multiselect'
import Loader  from '@/components/layout/Loader.vue'
import {mapActions} from 'vuex'
import FigureCurrencyNote from '@/components/layout/FigureCurrencyNote.vue'
export default {
    name : 'HleBoqItemsHistoryBreakdown',
    components : {
        Multiselect, Loader, BoqItemTableBreakdownReadOnly,
        ModalLineItemColumnFilter, BreadcrumbsProject,FigureCurrencyNote
    },
    computed : {
        isDeluxeLayout(){
            return this.$route.meta.layout === 'deluxe'
        }
    },
    mounted : async function(){
        const self = this
        self.boqItem = await GetHighLevelBoq(self.boqId)
        self.hleProject = await GetHighLevelProject(self.boqItem.hleProjectId)
        self.ChangeActiveLink(LinkList.HIGH_LEVEL_ESTIMATES)
        const boqItem = await GetHighLevelBoq(self.boqId)
        self.boqItem = boqItem
        self.section = await GetHleNewBoqCreatorSectionsRevisionsSection(self.parentId, self.boqId, self.revisionId)
        await self.GetData(self.boqListParams)
        const lineItemCols =  window.localStorage.getItem('lineItemColumns')
        if(lineItemCols){
            self.selectedColumns = lineItemCols.split(',').map(Number)
        }
        self.searchableAreas = GetDistinctValues(self.lineItems.map(u=>u.area).filter(value => value !== null && value !== undefined && value !== ''))
        self.searchableAreas.push(self.$i18n.t('NO SPACE ID'))
        const getLineItemCostCode = self.lineItems.map(u=>{
            return {
                _id : u.costCodeId,
                costName : u.costCode + ' ' +u.name
            }
        })
        self.searchableCostCodes = GetDistinctValuesObject(getLineItemCostCode)

    },
    data(){
        return {
            lineItems : [],
            hleProjectId : this.$route.params.id,
            boqId : this.$route.params.boqId,
            hleProject : {},
            boqItem : {
                currencyId : {}
            },
            revisionId : this.$route.query.revisionId,
            parentId : this.$route.params.parent,
            section : {},
            selectedArea : [],
            selectedCostCode : [],
            dataReady : false,
            OpenFilter : false,
            selectedColumns : [],
            boqListParams : {
                page : 1,
                parentId : this.$route.params.parent,
                revisionId : this.$route.query.revisionId,
                id :  this.$route.params.boqId,
                costCode : '',
                area : '',
                skip : 0,
                take : 50
            },
            boqUrlname : '',
            timerSearch : null
        }
    },
    methods : {
        ...mapActions(['ChangeActiveLink']),
        ClearField(type){
            if(type==1){
                this.selectedArea = []
            }
            else{
                this.selectedCostCode = []
            }
        },
        async GetData(){
            const self = this
            self.lineItems = []
            let willFetch = true
            self.boqListParams.skip = 0
            self.dataReady = false
            while(willFetch){
                const bits = await GetHighLevelBoqHistoryLineItemsByBits(self.boqListParams)
                if(bits.length!=0){
                    self.lineItems.push(...bits)
                }
                if(bits.length==self.boqListParams.take){
                    self.boqListParams.skip += 50
                }else{
                    willFetch = false
                }
            }

            self.dataReady = true
        },
        ChangeSelectecColumnValue(value){
            this.selectedColumns = value
        },
        TimerSetterSearch(callback){
            const self = this
            
            if(self.timerSearch){
                clearTimeout(self.timerSearch)
                self.timerSearch = null
            }

            self.timerSearch = setTimeout(callback,700)
        },
    },
    watch :{
        selectedCostCode(val){
            const self = this
            self.boqListParams.costCode = encodeURIComponent(JSON.stringify(val.map(u=>u._id)))
            self.boqListParams.area = encodeURIComponent(JSON.stringify(self.selectedArea))
            self.TimerSetterSearch(async function(){
                await self.GetData()
            })
        },
        selectedArea(val){
            const self = this
            self.boqListParams.costCode = encodeURIComponent(JSON.stringify(self.selectedCostCode.map(u=>u._id)))
            self.boqListParams.area = encodeURIComponent(JSON.stringify(val))
            self.TimerSetterSearch(async function(){
                await self.GetData()
            })
        },
    },
}
</script>
